var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainView"},[_c('MainComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }